const isBrowser = () => !!(
  (typeof window !== 'undefined'
          && window.document && window.document.createElement)
);
const helpers = {
  isBrowser,
};
export { isBrowser };
export default helpers;
